// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3up4K","unreadBadge":"styles_unreadBadge__oUjB-","modalContent":"styles_modalContent__1q0Bo","modal":"styles_modal__3fHpH"};